import React, {useEffect, useState} from 'react';
import styles from "../Logging.module.scss";
import LoggingHeader from "../components/LoggingHeader/LoggingHeader";
import LoggingFilter from "../components/LoggingFilter/LoggingFilter";
import {Icon, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow} from "semantic-ui-react";
import AppPagination from "../../../components/Pagination/AppPagination";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import { changePageSize, clearStackTrace, deleteException, getExceptions, getStackTrace, setPageNum } from "./LoggingExceptions.slice";
import { buildQueryString } from "../../../helpers/buildQueryString";
import moment from "moment/moment";
import StackTrace from "../components/StackTrace/StackTrace";
import LoggingConfirmModal from "../components/LoggingConfirmModal/LoggingConfirmModal";


const LoggingExceptions = () => {
    const dispatch = useAppDispatch()
    const [startDate, setStartDate] = useState<string | Date>(moment().toISOString());
    const [endDate, setEndDate] = useState<string | Date>(moment().add(24, "hours").toISOString());
    const [search, setSearch] = useState("");
    const [isShowStackTrace, setIsShowStackTrace] = useState(false);
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [deletingRecord, setDeletingRecord] = useState<string | number>("");
    const { pagination, exceptions } = useAppSelector(state => state.LoggingExceptions)

    useEffect(() => {
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize,from: startDate, to: endDate})
        dispatch(getExceptions(query))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const onSearch = (search: string) => {
        const query = buildQueryString({ pageNum: 1, pageSize: pagination.pageSize, search,from: startDate, to: endDate})
        dispatch(getExceptions(query))
        dispatch(setPageNum(1))
        setSearch(search)
    }

    const onChangeStartDate = (date: string) => {
        const from = moment(date).utc().format()
        const to = moment(endDate).utc().format()
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, search, from, to})
        setStartDate(date)
        dispatch(getExceptions(query))
    }

    const showStackTrace = (id: number | string) => {
        dispatch(getStackTrace(id))
        setIsShowStackTrace(true)
    }

    const closeStackTrace = () => {
        dispatch(clearStackTrace())
        setIsShowStackTrace(false)
    }

    const showConfirmModal = (id: number | string) => {
        setDeletingRecord(id)
        setIsShowConfirmModal(true)
    }

    const closeConfirmModal = () => {
        setDeletingRecord("")
        setIsShowConfirmModal(false)
    }
    const onDeleteException = () => {
        dispatch(deleteException(deletingRecord))
        setDeletingRecord("")
        setIsShowConfirmModal(false)
    }

    const onChangePageSize = (size: number) => {
        dispatch(changePageSize(size))
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: size, search,from: startDate, to: endDate})
        dispatch(getExceptions(query))
    }

    const onChangePageNum = (pageNum: number) => {
        dispatch(setPageNum(pageNum))
        const query = buildQueryString({ pageNum, pageSize: pagination.pageSize, search,from: startDate, to: endDate})
        dispatch(getExceptions(query))
    }

    return (
        <div className={styles.page}>
            {isShowStackTrace &&
                <StackTrace closeForm={closeStackTrace}/>
            }
            {isShowConfirmModal &&
                <LoggingConfirmModal
                    onDelete={onDeleteException}
                    text={`Are you sure you want to delete record with id ${deletingRecord}`}
                    onClose={closeConfirmModal}
                />
                }
            <LoggingHeader text={"Exceptions"}/>
            <div className={styles.container}>
                <LoggingFilter
                    search={search}
                    setSearch={onSearch}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={onChangeStartDate}
                    setEndDate={setEndDate}
                />
            </div>
            <div className={styles.tableInner}>
                <Table celled inverted>

                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell textAlign={'center'}>Id</TableHeaderCell>
                            <TableHeaderCell textAlign={'center'}>Time</TableHeaderCell>
                            <TableHeaderCell textAlign={'center'}>Type</TableHeaderCell>
                            <TableHeaderCell textAlign={'center'}>Message</TableHeaderCell>
                            <TableHeaderCell textAlign={'center'}></TableHeaderCell>
                        </TableRow>
                    </TableHeader>

                    <TableBody>
                        {exceptions.map(exception => {
                            return (
                                <TableRow>
                                    <TableCell textAlign='center'>{exception.id}</TableCell>
                                    <TableCell
                                        textAlign='center'>{moment(exception.date).local().format("YYYY-DD-MM HH:mm:ss")}</TableCell>
                                    <TableCell textAlign='center'>{exception.type}</TableCell>
                                    <TableCell textAlign='center'>{exception.message}</TableCell>
                                    <TableCell textAlign='center'>
                                        <button
                                            onClick={() => showStackTrace(exception.id)}
                                            className={styles.controlBtn}>
                                            <Icon color={"green"} name={"fire"}/>
                                        </button>
                                        <button
                                            onClick={()=>showConfirmModal(exception.id)}
                                            className={styles.controlBtn}>
                                            <Icon color={"red"} name={"trash alternate"}/>
                                        </button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}

                    </TableBody>
                </Table>
                <div className={styles.pagination}>
                    <AppPagination isInvertColor={true} props={pagination} onChangePageSize={onChangePageSize} onChangePager={onChangePageNum} />
                </div>
            </div>
        </div>
    );
};

export default LoggingExceptions;
